export default "__VITE_ASSET__a519d365__"